import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-informations-row-block',
  templateUrl: './informations-row-block.component.html',
})
export class InformationsRowBlockComponent {
  @Input() content!: string;
}
